import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { CONTACT } from "../data/content";

const LINKS = [
  { label: "Work", id: "work" },
  { label: "Services", id: "services" },
  { label: "Studio", id: "studio" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <motion.header
        data-testid="site-nav"
        initial={{ y: -80 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.3 }}
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
          scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
        }`}
      >
        <div className="mx-auto max-w-[1600px] px-6 md:px-12 h-28 flex items-center justify-between">
          <button
            data-testid="nav-logo"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center group"
          >
            <img
              src={CONTACT.logo}
              alt="RLP Photography and Production logo"
              className="h-[5.5rem] w-auto rounded-md"
            />
          </button>

          <nav className="hidden md:flex items-center gap-10">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-${l.id}`}
                onClick={() => go(l.id)}
                className="text-sm text-[#A1A1AA] hover:text-white transition-colors duration-300 uppercase tracking-wider"
              >
                {l.label}
              </button>
            ))}
            <a
              href="https://www.rlp-photography.com/book-online"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-book-online"
              className="text-sm text-[#A1A1AA] hover:text-white transition-colors duration-300 uppercase tracking-wider"
            >
              Book Online
            </a>
            <button
              data-testid="nav-book-cta"
              onClick={() => go("book")}
              className="bg-white text-black text-sm font-semibold px-6 py-2.5 rounded-full hover:bg-[#F5A623] transition-colors duration-300"
            >
              Booking Request
            </button>
          </nav>

          <button
            data-testid="nav-menu-toggle"
            className="md:hidden text-white"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 bg-black/95 backdrop-blur-xl flex flex-col items-center justify-center gap-8 md:hidden"
          >
            {LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                className="font-serif text-4xl text-white hover:text-[#F5A623] transition-colors duration-300"
              >
                {l.label}
              </button>
            ))}
            <a
              href="https://www.rlp-photography.com/book-online"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-book-online"
              className="font-serif text-4xl text-white hover:text-[#F5A623] transition-colors duration-300"
            >
              Book Online
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Nav;
